import locales from 'i18n/locales';
import { LanguageCode, Locale } from 'i18n/types';
import languageCode from './languageCode';

export default function isValidPathLocale(locale: LanguageCode): boolean {
  return locales.some(
    (definedLocale) => languageCode(definedLocale as Locale) === locale
  );
}
